import { FunctionComponent } from 'react';
import { useTranslation } from "../../TranslationContext";

import office_photo from "../../assets/png/office_photo.png";

const TransfersThatLast: FunctionComponent = () => {
	const translations = useTranslation();

	return (
		<div className="w-full relative bg-white overflow-hidden flex flex-col items-center justify-start py-20 px-20 box-border text-left text-4xl text-nebula-900 font-text-base-font-normal lg:text-3xl md:text-2xl lg:px-10 md:px-6 md:py-16">
			<div className="w-full flex flex-col items-center justify-start max-w-[1280px]">
				<div className="self-stretch flex flex-row items-start justify-start gap-24 xl:gap-12 sm:flex-col">
					<img className="w-[400px] lg:w-[300px] relative rounded-[19.9px] max-h-full object-cover" alt="" src={office_photo} />
					<div className="flex-1 flex flex-col items-center justify-center gap-6">
						<div className="self-stretch relative tracking-[-0.01em] leading-[125%] font-extrabold">
							{translations.transfersThatLast.title}
						</div>
						<div className="self-stretch relative text-base leading-[150%] text-slate-950 lg:text-sm">
							{translations.transfersThatLast.paragraphs.map((paragraph: string, index: number) => (
								<p key={index} className="mb-4">{paragraph}</p>
							))}
						</div>
					</div>
				</div>
			</div>
		</div>);
};

export default TransfersThatLast;
